import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * 메인 화면의 버스 안내.
 * 예전에는 차종마다 자동 슬라이드를 돌렸는데, 화면을 가리고 넘어가는 사진을
 * 붙잡기 어려워 차종별 대표 사진 한 장만 화면 폭에 맞춰 보여준다.
 */
const BUS_TYPES = [
  { name: '25인승 소형', url: '/image/smallBusExterior.jpg?v=2' },
  { name: '28인승 대형 리무진', url: '/image/limousineExterior.jpg?v=3' },
  { name: '45인승 대형', url: '/image/bigBusExterior.jpg?v=2' },
];

export default function BusSlider() {
  return (
    <Box sx={{ width: '100%', maxWidth: 900, m: 'auto', mt: '2em', px: 2, textAlign: 'center' }}>
      <Typography
        sx={{
          p: '10px',
          mb: '24px',
          borderRadius: '10px',
          backgroundColor: '#EC9F46',
          color: '#FCFCFC',
          fontWeight: 700,
        }}
      >
        버스 안내
      </Typography>

      {BUS_TYPES.map((bus) => (
        <Box key={bus.name} sx={{ mb: 4 }}>
          <Typography sx={{ color: '#5A4231', fontSize: 18, fontWeight: 'bold', mb: 1.5 }}>
            {bus.name}
          </Typography>
          <Box
            component='img'
            src={bus.url}
            alt={`${bus.name} 버스`}
            loading='lazy'
            sx={{
              display: 'block',
              width: '100%',
              /* 원본보다 크게 늘리면 흐릿해진다 */
              maxWidth: 720,
              height: 'auto',
              m: '0 auto',
              borderRadius: '10px',
            }}
          />
        </Box>
      ))}
    </Box>
  );
}
